/**
 * Handle custom on:click attributes throughout the theme
 * This script processes elements with on:click attributes and sets up click handlers
 */

document.addEventListener('DOMContentLoaded', function() {
  // Handle all elements with on:click attributes
  document.addEventListener('click', async function(event) {
    const element = event.target.closest('[on\\:click]');
    if (!element) return;
    
    const onClickValue = element.getAttribute('on:click');
    if (!onClickValue) return;
    
    // Handle zoom dialog opening
    if (onClickValue.startsWith('#zoom-dialog-') && onClickValue.includes('/open/')) {
      event.preventDefault();
      event.stopPropagation();
      
      const parts = onClickValue.split('/');
      const dialogId = parts[0].substring(1); // Remove the #
      const slideIndex = parseInt(parts[2], 10);
      
      // Find and open the zoom dialog
      const dialog = document.getElementById(dialogId);
      
      if (dialog && typeof dialog.open === 'function') {
        try {
          await dialog.open(slideIndex, event);
        } catch (error) {
          console.error('Error opening dialog:', error);
        }
      }
    }
    
    // Handle dialog opening
    if (onClickValue.startsWith('/openDialog|#')) {
      event.preventDefault();
      event.stopPropagation();
      
      const dialogId = onClickValue.split('|#')[1];
      const dialog = document.getElementById(dialogId);
      
      if (dialog) {
        dialog.showModal();
      }
    }
    
    // Handle dialog closing
    if (onClickValue.startsWith('/closeDialog|#')) {
      event.preventDefault();
      event.stopPropagation();
      
      const dialogId = onClickValue.split('|#')[1];
      const dialog = document.getElementById(dialogId);
      
      if (dialog) {
        dialog.close();
      }
    }
    
    // Handle other on:click actions as needed
    // Add more cases here for other custom attributes
  });
});
